import { FeatureFlagClient } from '@acv/feature-flag-javascript';
import featureFlagSlugs from '@/constants/featureFlagSlugs';
import { installInterceptors } from '@/api/interceptors';

class FeatureFlagsClient {
  constructor(tokens) {
    let environment = import.meta.env.VITE_ENV_NAME?.toString().toLowerCase() || 'latest';
    if (!['uat', 'latest', 'premerge', 'development', 'staging', 'production'].includes(environment?.toString().toLowerCase())) {
      throw new Error(`INVALID ENVIRONMENT SPECIFIED FOR FEATURE FLAGS. VALID OPTIONS: premerge, uat, latest, staging, production. Passed: ${environment}`);
    }

    if (['uat', 'premerge', 'development'].includes(environment?.toString().toLowerCase())) {
      environment = 'latest';
    }
    const {
      jwtToken,
      refreshToken,
    } = tokens;

    const acvServiceName = 'acv-web-vuejs';

    const headers = {
      'acv-client-version': import.meta.env.VITE_VERSION,
    };

    this.environment = environment;
    this.flagClient = new FeatureFlagClient(
      jwtToken,
      refreshToken,
      acvServiceName,
      environment,
      headers,
      0,
    );

    // Uninstall Interceptors that handle JWT refreshes. The web app handles it behind the scenes
    this.flagClient.uninstallInterceptors();
    installInterceptors(this.flagClient.baseApiClient.axiosInstance);
    this.awaitingPromise = null;
    this.featureFlagRetries = 0;
  }

  get(flagSlug) {
    return this.flagClient.getFeatureFlag(flagSlug);
  }

  getFlagGroup(flagSlugs) {
    return this.flagClient.getFeatureFlagGroup(flagSlugs);
  }

  getAllFlags() {
    if (!this.awaitingPromise) {
      this.awaitingPromise = this.getFlagGroup(Object.values(featureFlagSlugs))
        .finally(() => {
          this.awaitingPromise = null;
        });
    }

    return this.awaitingPromise;
  }
}

export default FeatureFlagsClient;
